var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _require = require('crypto'),
    generateKeyPairSync = _require.generateKeyPairSync,
    async = _require.generateKeyPair;

var _require2 = require('util'),
    promisify = _require2.promisify;

var _require3 = require('../../help/consts'),
    THUMBPRINT_MATERIAL = _require3.THUMBPRINT_MATERIAL,
    JWK_MEMBERS = _require3.JWK_MEMBERS,
    PUBLIC_MEMBERS = _require3.PUBLIC_MEMBERS,
    PRIVATE_MEMBERS = _require3.PRIVATE_MEMBERS,
    KEY_MANAGEMENT_DECRYPT = _require3.KEY_MANAGEMENT_DECRYPT,
    KEY_MANAGEMENT_ENCRYPT = _require3.KEY_MANAGEMENT_ENCRYPT;

var _require4 = require('../../registry'),
    OKP_CURVES = _require4.OKP_CURVES;

var _require5 = require('../../help/runtime_support'),
    edDSASupported = _require5.edDSASupported;

var errors = require('../../errors');

var Key = require('./base');

var generateKeyPair = promisify(async);
var OKP_PUBLIC = new Set(['crv', 'x']);
Object.freeze(OKP_PUBLIC);
var OKP_PRIVATE = new Set([].concat(_toConsumableArray(OKP_PUBLIC), ['d']));
Object.freeze(OKP_PRIVATE); // Octet string key pairs Key Type

var OKPKey =
/*#__PURE__*/
function (_Key) {
  "use strict";

  _inherits(OKPKey, _Key);

  function OKPKey() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OKPKey);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OKPKey)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this[JWK_MEMBERS]();

    Object.defineProperty(_assertThisInitialized(_this), 'kty', {
      value: 'OKP',
      enumerable: true
    });

    if (!OKP_CURVES.has(_this.crv)) {
      throw new errors.JOSENotSupported('unsupported OKP key curve');
    }

    return _this;
  }

  _createClass(OKPKey, [{
    key: THUMBPRINT_MATERIAL,
    // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
    // JSON.stringify handling in V8
    value: function value() {
      return {
        crv: this.crv,
        kty: 'OKP',
        x: this.x
      };
    }
  }, {
    key: KEY_MANAGEMENT_ENCRYPT,
    value: function value() {
      return this.algorithms('deriveKey');
    }
  }, {
    key: KEY_MANAGEMENT_DECRYPT,
    value: function value() {
      if (this.public) {
        return new Set();
      }

      return this.algorithms('deriveKey');
    }
  }], [{
    key: "generate",
    value: function generate() {
      var crv,
          privat,
          _ref,
          privateKey,
          publicKey,
          _args = arguments;

      return _regeneratorRuntime.async(function generate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              crv = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'Ed25519';
              privat = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;

              if (edDSASupported) {
                _context.next = 4;
                break;
              }

              throw new errors.JOSENotSupported('OKP keys are not supported in your Node.js runtime version');

            case 4:
              if (OKP_CURVES.has(crv)) {
                _context.next = 6;
                break;
              }

              throw new errors.JOSENotSupported("unsupported OKP key curve: ".concat(crv));

            case 6:
              _context.next = 8;
              return _regeneratorRuntime.awrap(generateKeyPair(crv.toLowerCase()));

            case 8:
              _ref = _context.sent;
              privateKey = _ref.privateKey;
              publicKey = _ref.publicKey;
              return _context.abrupt("return", privat ? privateKey : publicKey);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      });
    }
  }, {
    key: "generateSync",
    value: function generateSync() {
      var crv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ed25519';
      var privat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!edDSASupported) {
        throw new errors.JOSENotSupported('OKP keys are not supported in your Node.js runtime version');
      }

      if (!OKP_CURVES.has(crv)) {
        throw new errors.JOSENotSupported("unsupported OKP key curve: ".concat(crv));
      }

      var _generateKeyPairSync = generateKeyPairSync(crv.toLowerCase()),
          privateKey = _generateKeyPairSync.privateKey,
          publicKey = _generateKeyPairSync.publicKey;

      return privat ? privateKey : publicKey;
    }
  }, {
    key: PUBLIC_MEMBERS,
    get: function get() {
      return OKP_PUBLIC;
    }
  }, {
    key: PRIVATE_MEMBERS,
    get: function get() {
      return OKP_PRIVATE;
    }
  }]);

  return OKPKey;
}(Key);

module.exports = OKPKey;